/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormWaiversAndNgbWaiversResponse } from '../models/FormWaiversAndNgbWaiversResponse';
import type { NgbDivisionsResponse } from '../models/NgbDivisionsResponse';
import type { NgbMemberResponse } from '../models/NgbMemberResponse';
import type { OpenApiInteger } from '../models/OpenApiInteger';
import type { ValidateMembershipRequest } from '../models/ValidateMembershipRequest';
import type { ValidateMembershipResponse } from '../models/ValidateMembershipResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NgbIntegrationsService {

    /**
     * @param ngbIntegrationId
     * @param requestBody
     * @returns ValidateMembershipResponse Success
     * @throws ApiError
     */
    public static validateMembership(
        ngbIntegrationId: OpenApiInteger,
        requestBody: ValidateMembershipRequest,
    ): CancelablePromise<ValidateMembershipResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ngb-integrations/{ngbIntegrationId}/validate-membership',
            path: {
                'ngbIntegrationId': ngbIntegrationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param ngbIntegrationId
     * @param organizationId
     * @param formId
     * @param seasonStartDate
     * @param seasonEndDate
     * @returns FormWaiversAndNgbWaiversResponse Success
     * @throws ApiError
     */
    public static getNgbWaivers(
        ngbIntegrationId: OpenApiInteger,
        organizationId: OpenApiInteger,
        formId: OpenApiInteger,
        seasonStartDate: string,
        seasonEndDate: string,
    ): CancelablePromise<FormWaiversAndNgbWaiversResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ngb-integrations/{ngbIntegrationId}/get-ngb-waivers',
            path: {
                'ngbIntegrationId': ngbIntegrationId,
            },
            query: {
                'organizationId': organizationId,
                'formId': formId,
                'seasonStartDate': seasonStartDate,
                'seasonEndDate': seasonEndDate,
            },
        });
    }

    /**
     * @param ngbIntegrationId
     * @param personUuid
     * @returns NgbMemberResponse Success
     * @throws ApiError
     */
    public static getNgbMember(
        ngbIntegrationId: OpenApiInteger,
        personUuid?: string,
    ): CancelablePromise<NgbMemberResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ngb-integrations/{ngbIntegrationId}/get-ngb-member',
            path: {
                'ngbIntegrationId': ngbIntegrationId,
            },
            query: {
                'personUuid': personUuid,
            },
        });
    }

    /**
     * @param ngbIntegrationId
     * @param memberId
     * @param organizationId
     * @returns NgbDivisionsResponse Success
     * @throws ApiError
     */
    public static getNgbAvailableMemberDivisions(
        ngbIntegrationId: OpenApiInteger,
        memberId: string,
        organizationId: OpenApiInteger,
    ): CancelablePromise<NgbDivisionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ngb-integrations/{ngbIntegrationId}/get-available-member-divisions',
            path: {
                'ngbIntegrationId': ngbIntegrationId,
            },
            query: {
                'memberId': memberId,
                'organizationId': organizationId,
            },
        });
    }

}
